import {
  Box,
  Drawer,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { AdminReviewSessionViewDto } from "@swagger/typescript-fetch-goflyer";
import { messages } from "../../../../../locales/messages";
import { FlyerCommentsPanel } from "./index";

interface Props {
  open: boolean;
  onClose: () => void;
  flyerId: string;
  reqOptions: { headers: { Authorization: string } };
  bootstrap: AdminReviewSessionViewDto | undefined;
}

export function FlyerCommentsDrawer({
  open,
  onClose,
  flyerId,
  reqOptions,
  bootstrap,
}: Props) {
  const { t } = useTranslation();

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: { xs: "100%", sm: 480 } } }}
      data-testid="flyer-comments-drawer"
    >
      <Box
        sx={{
          px: 2,
          py: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6" component="h2">
          {t(messages.Flyer_Comments())}
        </Typography>
        <IconButton onClick={onClose} size="small" aria-label="close">
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
      <Box sx={{ p: 2, flex: 1, overflowY: "auto" }}>
        <FlyerCommentsPanel
          flyerId={flyerId}
          reqOptions={reqOptions}
          bootstrap={bootstrap}
        />
      </Box>
    </Drawer>
  );
}
